/** Km del tablero: '174.374' / 174374 / '174374 km' -> 174374; vacío o inválido -> null (mismo criterio que el server) */
export const parseKm = (value: unknown): number | null => {
  if (value == null) return null;
  const digits = String(value).replace(/\D/g, '');
  if (!digits) return null;
  const km = parseInt(digits, 10);
  return Number.isFinite(km) && km > 0 ? km : null;
};

export const formatKm = (value: unknown): string => {
  const km = parseKm(value);
  return km == null ? '' : `${km.toLocaleString('es-AR')} km`;
};

/** Aviso (no bloquea) cuando el número no cierra contra la ficha del vehículo */
export const avisoKm = (value: unknown, kmFicha?: number | null): string | null => {
  const km = parseKm(value);
  const ficha = parseKm(kmFicha);
  if (km == null || ficha == null) return null;
  if (km < ficha) return `Es menos de lo que dice la ficha (${ficha.toLocaleString('es-AR')} km). Revisá el número.`;
  if (km - ficha > 200000) return `Son ${(km - ficha).toLocaleString('es-AR')} km más que la ficha: ¿no sobra un dígito?`;
  return null;
};
